import React, { useEffect, useState, useMemo } from 'react';
import Input from '../Inputs/Input';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import { CollectionStoreActions } from '../../Reducers/CollectionStore.reducer';
import { translate } from '../../Services/translation';

const CollectionStoreInput = () => {
  const [searchField, setSearchField] = useState('');
  const { collectionItems } = useTypedSelector(
    (state) => state.CollectionStoreReducer
  );

  const dispatch = useDispatch();

  const filteredItems = useMemo(() => {
    return collectionItems.filter((item) =>
      item.name.toLowerCase().includes(searchField.toLowerCase())
    );
  }, [collectionItems, searchField]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchField(e.target.value.toLowerCase());
  };
  
  useEffect(() => {
    dispatch(
      CollectionStoreActions.SetFilteredItems({
        items: filteredItems,
      })
    );
  }, [dispatch, filteredItems]);

  return (
    <Input
      onChange={onChange}
      className="w-full bg-gray-100 p-4"
      icon="search"
      inputSize="large"
      placeholder={translate('general.search')}
    />
  );
};

export default CollectionStoreInput;
